import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import { Carousel as BSCarousel } from 'react-bootstrap';

import { ICON_MOVE_OR_SCROLL_LEFT, ICON_MOVE_OR_SCROLL_RIGHT } from 'Config/Icons';

import styles from './Carousel.module.css';

interface CarouselProps {
    children: JSX.Element[];
    showControls?: boolean;
    showIndicators?: boolean;
}

export const Carousel = (props: CarouselProps): JSX.Element => {
    return (
        <BSCarousel className={styles.carousel} controls={props.showControls !== undefined ? props.showControls : false} interval={null} indicators={props.showIndicators !== undefined ? props.showIndicators : true} nextIcon={<FontAwesomeIcon icon={ICON_MOVE_OR_SCROLL_RIGHT} size="xl" />} prevIcon={<FontAwesomeIcon icon={ICON_MOVE_OR_SCROLL_LEFT} size="xl" />}>
            {props.children}
        </BSCarousel>
    );
};
